import { models } from "../omnia"

export type IMap = omnia.map.IMap

export import SatImageType = models.SatImageType
import { ImageryProviderId } from "./providers"

export enum ImageryLayerStatus {
    NotSet = 0,
    Pending = 1,
    Running = 2
}

export type ImageryLayer = Imagery["layers"][0]

export interface Imagery {

    readonly boundaryId: string
    readonly fieldId: number
    readonly type: SatImageType
    readonly date: Date

    readonly extent: number[]
    readonly imageUrl: string

    readonly layers: {
        readonly croppingId: number
        readonly layerId: number
        readonly layerStatus: ImageryLayerStatus
    }[]

}


export interface ImageryProvider {
    providerId: ImageryProviderId
    dates: ImageryDate[]
}

export interface Boundary {
    readonly boundaryId: string
    readonly fieldId: number
    readonly inactive: boolean
}

export interface ImageryDate {

    /** Type (NDVI, CHI, ...) */
    readonly type: SatImageType

    /** Date */
    readonly date: Date

    /** Number of boundaries with images available on this date */
    readonly boundaries: number

    /** Number of layers generated on this date */
    readonly layers: number

    /** Number of layer tasks pending */
    readonly layerTasksPending: number

    /** Number of layer tasks pending */
    readonly layerTasksRunning: number

}
